import RequireAuth from "@/components/hoc/RequireAuth";
import RootLayout from "@/components/layout/RootLayout";
import useInjectSidebar from "@/hooks/useInjectSidebar";
import DashboardFinder from "@/pages/dashboard/DashboardFinder";
import DashboardFinderLayout from "@/pages/dashboard/DashboardFinderLayout";
import DashboardViewer from "@/pages/dashboard/_id/DashboardViewer";
import DashboardViewerLayout from "@/pages/dashboard/_id/DashboardViewerLayout";
import { Navigate } from "react-router-dom";

const AppLayout = () => {
    const Root = useInjectSidebar({ sidebarName: "workspace" })(RootLayout);
    return <RequireAuth>{Root}</RequireAuth>;
};

export const dashboardRoute = {
    path: "/dashboard-hub",
    element: <AppLayout />,
    children: [
        {
            index: true,
            element: <Navigate to="/dashboard-hub/search" replace={true} />,
        },
        {
            path: "search",
            element: <DashboardFinderLayout />,
            children: [
                {
                    index: true,
                    element: <DashboardFinder />,
                },
            ],
        },
        {
            path: "view/:dashboardId",
            element: <DashboardViewerLayout />,
            children: [
                {
                    index: true,
                    element: <DashboardViewer />,
                },
            ],
        },
    ],
};
